import React, { useEffect, useState } from "react";
// import swiper
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper";
// import component
import ProductCard from "../../components/product_card/ProductCard";
import "./CategoryPage.scss";
const CategoryPage = () => {
  const [Products, setproduct] = useState([]);
  useEffect(() => {
    fetch("https://rus-digital-televisions.onrender.com/mobilesandtablets")
      .then((res) => res.json())
      .then((data) => setproduct(data))
      .catch((error) => {
        console.log(error);
      });
    selectoneBox();
  }, []);
  // array of categories
  const Categories = [
    {
      id: 1,
      label: "mobilesandtablets",
      color: "White ",
      order: "Most Popular",
      checked: true,
    },
    { id: 2, label: "computers", color: " Blue", order: "Best Rating" },
    { id: 3, label: "televisions", color: "Black ", order: "Newest" },
    { id: 4, label: "headphones", color: "Brown ", order: "popular" },
    {
      id: 6,
      label: "accessories",
      color: " yellow",
      order: "Price Low - Height",
    },
    {
      id: 5,
      label: "allproduct",
      color: " Green",
      order: "Price Height - Low",
    },
  ];
  // function of select on box
  const selectoneBox = () => {
    let allInputs = document.querySelectorAll(".Categories div input");
    allInputs.forEach((input) => {
      input.addEventListener("click", (e) => {
        allInputs.forEach((inpu) => {
          inpu.checked = false;
          showspinner();
        });
        input.checked = true;
        let api = `https://rus-digital-televisions.onrender.com/${input.value}`;
        fetch(api)
          .then((res) => res.json())
          .then((data) => setproduct(data));
      });
    });
    showspinner();
  };
  // show spinner and hide products
  const [spinner, setspinner] = useState(false);
  const [products, showproducts] = useState(true);
  const showspinner = () => {
    setspinner(true);
    showproducts(false);
    setTimeout(() => {
      setspinner(false);
      showproducts(true);
    }, 2700);
  };
  return (
    <>
      <div className="CategoryPage">
        <div className="container-fluid">
          <div className="title">
            <h3 style={{ fontSize: "29px", fontWeight: "700" }}>
              Our Products
            </h3>
            <p style={{ color: "gray", fontSize: "16px" }}>
              We not only help you design exceptional products, but also make it
              easy for you<br></br> to share your designs with more like-minded
              people.
            </p>
          </div>
          <div className="Category-content">
            <div className="row">
              <aside className="col-lg-3 col-md-6 col-sm-12 ">
                {/* start category */}
                <div className="Categories">
                  <h4>Categories</h4>
                  {Categories.map((category) => {
                    return (
                      <div key={category.id}>
                        <input type="checkbox" value={category.label}></input>
                        <label>{category.label}</label>
                      </div>
                    );
                  })}
                </div>
                {/* start colors div */}
                <div className="colors">
                  <h4>Colore</h4>
                  {Categories.map((category) => {
                    return (
                      <div key={category.id}>
                        <input type="checkbox"></input>
                        <label>{category.color}</label>
                      </div>
                    );
                  })}
                </div>
                {/* start colors */}
                <div className="colors">
                  <h4>Sort order</h4>
                  {Categories.map((category) => {
                    return (
                      <div key={category.id}>
                        <input type="checkbox"></input>
                        <label>{category.order}</label>
                      </div>
                    );
                  })}
                </div>
              </aside>
              {products && (
                <div
                  className="col-lg-9 col-md-6 col-sm-12"
                  style={{
                    marginTop: "57px",
                    position: "relative",
                  }}
                >
                  <div className="categorypage_Navigation">
                    <div className="swiper-button-next"></div>
                    <div className="swiper-button-prev"></div>
                  </div>
                  <div className="row">
                    <Swiper
                      loop={true}
                      breakpoints={{
                        401: {
                          slidesPerView: 2,
                          spaceBetween: 10,
                        },
                        // when window width is >= 480px
                        480: {
                          slidesPerView: 2,
                          spaceBetween: 10,
                        },

                        // when window width is >= 640px
                        640: {
                          slidesPerView: 2,
                          spaceBetween: 10,
                        },
                        767: {
                          slidesPerView: 3,
                          spaceBetween: 10,
                        },
                        992: {
                          slidesPerView: 3,
                          spaceBetween: 10,
                        },
                      }}
                      navigation={{
                        clickable: true,
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev",
                      }}
                      modules={[Navigation]}
                      className="mySwiper productsSwipper"
                    >
                      {Products.map((product) => {
                        return (
                          <SwiperSlide key={product.id}>
                            <ProductCard
                              productimg={product.img}
                              name={product.name.slice(0, 60)}
                              discount={product.mrp}
                              price={product.price}
                              productdetails={product}
                            />
                          </SwiperSlide>
                        );
                      })}
                    </Swiper>
                  </div>
                </div>
              )}
            </div>
          </div>
          {spinner && <span className="loader"></span>}
        </div>
      </div>
    </>
  );
};

export default CategoryPage;
